import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import Formsy from 'formsy-react';
import { kebabCase } from 'lodash';
import { Row, Col, Button, Label, FormGroup, DefaultSheet, SheetBody, Select as SelectPure, SheetFooter } from 'twyne-new.ui';

import InfoTip from 'components/InfoTip';
import Input from 'components/form/Input';
import Select from 'components/form/Select';
import Switch from 'components/form/Switch';
import history from 'utils/history';

class FormComponent extends React.Component {
  state = {
    active: true,
    slugTouch: false,
    consent_steps: [],
    disable_continue_button: false
  }

  componentWillMount() {
    let data = this.props.data;
    if (data) {
      data.slugTouch = true
      this.setState(data, () => this.calculateSteps());
    }
  }

  handleValidSubmit = (model) => {
    if (this.state.registration_step == null)
      this.state.registration_step = -1
    model.meta.anchor_custom_element = this.state.meta ? this.state.meta.anchor_custom_element : null
    this.props.handleSubmit(Object.assign(this.state, model))
  }

  handleCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    } else {
      history.goBack();
    }
  }

  calculateSteps() {
    let consent_steps = []
    consent_steps.push({ value: -1, label: "Do not show" })
    for (let index = 1; index <= this.state.step; index++) {
      consent_steps.push({ value: index, label: index })
    }
    this.setState({ consent_steps })
  }

  handleOnChange = (key, value) => {
    let step = value
    let conversion_step
    switch (key) {
      case "name":
        let name = value

        if (!this.state.slugTouch) {
          this.setState({
            slug: kebabCase(value)
          });
        }

        this.setState({ name })
        break
      case "step":
        conversion_step = this.state.conversion_step
        step = value || 0
        if (step < conversion_step)
          conversion_step = step

        this.setState({ step: step, conversion_step: conversion_step }, () => this.calculateSteps())
        break
      case "conversion_step":
        step = parseInt(this.state.step, 10) || 0
        let value_cv = parseInt(value, 10) || 0
        conversion_step = value_cv > step ? step : value_cv
        this.setState({ conversion_step })
        break
      default:
        let store = this.state
        store[key] = value
        this.setState(store)
        break
    }
  }

  onChangeSlug = (event) => {
    const value = event.currentTarget.value;
    const slugTouch = value && value.length

    this.setState({
      slugTouch: slugTouch,
      slug: value
    })
  }

  slugAlreadyExists = (slug) => {
    return this.props.slugs && this.props.slugs.includes(slug)
  }

  Steps = () => {
    const { id, step } = this.state
    const [value, setValue] = useState('')

    useEffect(() => {
      if (this.state.definition)
        setValue(this.state.definition.length || '')

    }, [this.state.definition && this.state.definition.length])

    if (!id)
      return null

    return <Col size="6">
      <FormGroup>
        <Label>Steps</Label>
        <Input disabled required
          type="number"
          name="step"
          onChange={(e) => this.handleOnChange("step", e.target.value)}
          value={step || ''}
        />
      </FormGroup>
    </Col>

  }

  ConversionStep = () => {
    const { id, step, conversion_step } = this.state
    const [options, setOptions] = useState([])

    useEffect(() => {
      const options = Array(step || null)
        .fill(null)
        .map((_, i) => ({
          label: i + 1,
          value: i + 1
        }))

      setOptions(options)
    }, [step])

    if (!id)
      return null

    return <Col size="6">
      <FormGroup>
        <Label>Conversion Step</Label>
        <Select required
          name="conversion_step"
          onChange={(e) => this.handleOnChange("conversion_step", e.value)}
          options={options}
          value={conversion_step || ''}
        />
      </FormGroup>
    </Col>

  }

  effectsOptions = [
    { label: 'None', value: '' },
    { label: 'Slide Top', value: 'slideTop' },
    { label: 'Slide Bottom', value: 'slideBottom' },
    { label: 'Slide Right', value: 'slideRight' },
    { label: 'Slide Left', value: 'slideLeft' },
    { label: 'Fade', value: 'fade' }
  ]

  effectsDurationsOptions = [
    {
      label: 'None',
      value: ''
    },
    {
      label: '250 mills',
      value: '1'
    }, {
      label: '500 mills',
      value: '2'
    }, {
      label: '1000 mills',
      value: '3'
    }, {
      label: '1500 mills',
      value: '4'
    }, {
      label: '2000 mills',
      value: '5'
    }
  ]

  AllowedOnOptions = [
    {
      label: 'Pages',
      value: 'pages'
    }, {
      label: 'Allocations',
      value: 'allocations'
    }
  ]

  DeviceTypeOptions = [
    {
      label: 'Mobile',
      value: 'mobile'
    }, {
      label: 'Desktop',
      value: 'desktop'
    }
  ]

  AnchorOptions = [
    {
      label: 'Top of the page',
      value: 'page_top',
      custom: false,
    }, {
      label: 'First field of the step',
      value: 'first_field',
      custom: false,
    },
  ]

  TransitionEffects = ({ onChange, data }) => {
    data = data || {}

    const handleChange = (field, value) => {
      onChange({
        ...data,
        [field]: value
      })
    }
    return <>

      <Col size="6">
        <FormGroup>
          <Label>Transition Effect</Label>
          <Select
            name="meta.effect"
            onChange={(e) => handleChange('effect', e.target.value)}
            options={this.effectsOptions}
            value={data.effect || ''}
          />
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <Label>Transition Duration</Label>
          <Select
            name="meta.effect_duration"
            onChange={(e) => handleChange('effect_duration', e.target.value)}
            options={this.effectsDurationsOptions}
            value={data.effect_duration || ''}
          />
        </FormGroup>
      </Col>
    </>
  }

  MultiSelect = ({ field, label, options }) => {
    const handleChange = (options) => {
      const state = this.state

      if (!options.length)
        state[field] = null
      else
        state[field] = options.map(option => option.value).filter(value => value !== '')

      this.setState(state)
    }

    const getValue = () => {
      const value = this.state[field]

      if(value && Array.isArray(value))
        return value.map(value => (options.find(option => option.value === value)))

      return [{ label: 'all', value: '' }]
    }

    return <Col size="6">
      <FormGroup>
        <Label>{label}</Label>
        <SelectPure
          options={options}
          onChange={(options) => handleChange(options)}
          value={getValue()}
          multi
          required
        />
      </FormGroup>
    </Col>
  }

  AnchorSelectCreatable = () => {
    const { anchor: anchorState, meta } = this.state
    const { anchor_custom_element: anchorCustomElement } = meta || {}

    const [anchorOptions, setAnchorOptions] = useState(this.AnchorOptions)
    const [anchor, setAnchor] = useState('')

    useEffect(() => {
      if (anchorCustomElement) {
        setAnchor(anchorCustomElement)
      } else {
        setAnchor(anchorState)
      }
    }, [anchorCustomElement, anchorState])

    useEffect(() => {
      if (anchor) {
        const defaultValue = anchorOptions.find(item => item.value === anchor)
        if (!defaultValue) {
          const newOptions = [{ label: `Custom class: ${anchor}`, value: anchor, custom: true }, ...anchorOptions]
          setAnchorOptions(newOptions)
        }
      }
    }, [anchor, anchorOptions])

    const isValidSelector = value => {
      try {
        document.querySelector(value)
        const regex = /^[a-zA-Z0-9_-]+$/
        return regex.test(value)
      } catch (e) {
        return false
      }
    }

    const isValidNewOption = label => {
      if (!label || !typeof label === 'string' || !label.length || !isValidSelector(label)) {
        return false
      }

      return true
    }

    const promptTextCreator = str => `Anchor to the custom element class "${str}"`

    const newOptionCreator = ({ label }) => {
      const value = label.trim()
      label = `Custom class: ${label.trim()}`
      label = label.replace('Custom class: Anchor to the custom element class', 'Anchor to the custom element class')
      return { label, value, custom: true }
    }

    const onChangeAnchor = item => {
      setAnchor(item.value)

      if (item.custom) {
        return this.setState({ meta: { ...this.state.meta, anchor_custom_element: item.value } })
      }

      this.setState({ meta: { ...this.state.meta, anchor_custom_element: null } })
      return this.setState({ anchor: item.value })
    }

    return <>
      <SelectPure
        creatable
        required
        name="meta.anchor_custom_element"
        value={anchor || ''}
        options={anchorOptions}
        onChange={item => item && onChangeAnchor(item)}
        isValidNewOption={isValidNewOption}
        promptTextCreator={promptTextCreator}
        newOptionCreator={newOptionCreator}
      />
    </>
  }

  render() {
    return <DefaultSheet
      wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && this.handleCancel() }}
      title={this.state.id ? "Edit Form Details" : 'Create New Form'}
      trigger={this.props.trigger || null}
    >
      <Formsy onValidSubmit={this.handleValidSubmit}>
        <SheetBody>
          <Row>
            <Col size="6">
              <FormGroup>
                <Label>Name</Label>
                <Input name="name" value={this.state.name || ''} onChange={e => this.handleOnChange("name", e.target.value)} required />
              </FormGroup>
            </Col>
            <Col size="6">
              <FormGroup>
                <Label>Slug</Label>
                <Input
                  name="slug"
                  value={this.state.slug || ''}
                  onChange={this.onChangeSlug}
                  required
                  validations={{ isSlugUnique: (_, value) => !this.slugAlreadyExists(value) }}
                  validationErrors={{ isSlugUnique: 'This slug already exists.' }}
                />
              </FormGroup>
            </Col>
            <this.Steps />
            <this.ConversionStep />
            {['form1', 'form2', 'form3'].includes(this.state.slug) && <>
              <Col size="12">
                <Row>
                  <Col size="4" key='1'>
                    <FormGroup>
                      <Label>Registration Consent</Label>
                      <Select name="consent_step" onChange={e => this.handleOnChange("consent_step", e.value)} options={this.state.consent_steps} value={this.state.consent_step} required />
                    </FormGroup>
                  </Col>
                  <Col size="4" key='2'>
                    <FormGroup>
                      <Label>TCPA Consent</Label>
                      <Select name="tcpa_step" onChange={e => this.handleOnChange("tcpa_step", e.value)} options={this.state.consent_steps} value={this.state.tcpa_step} required />
                    </FormGroup>
                  </Col>
                  <Col size="4" key='3'>
                    <FormGroup>
                      <Label>Registration Adserve</Label>
                      <Select name="registration_step" onChange={e => this.handleOnChange("registration_step", e.value)} options={this.state.consent_steps} value={this.state.registration_step} required />
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </>}
            <this.TransitionEffects data={this.state.meta} onChange={this.handleOnChange.bind(this, "meta")} />
            <this.MultiSelect field="allowed_on" label="Allowed On" options={this.AllowedOnOptions}/>
            <this.MultiSelect field="device_type" label="Device Type" options={this.DeviceTypeOptions}/>
            <Col size="6">
              <FormGroup>
                <Label>Submit Button Label</Label>
                <Input type="text" name="submit_label" onChange={(e) => this.handleOnChange("submit_label", e.target.value)} value={this.state.submit_label || ''} required />
              </FormGroup>
            </Col>
            <Col size="6">
              <FormGroup>
                <Label>
                  Anchor
                  <InfoTip>
                    It is possible to type custom classes for anchoring
                  </InfoTip>
                </Label>
                <this.AnchorSelectCreatable />
              </FormGroup>
            </Col>
            <Col size="6">
              <FormGroup>
                <Label>
                  Progress Events
                  <InfoTip>
                    Progress calculation method options: Filled Values: All populated values. User Input: Values entered manually by the user
                  </InfoTip>
                </Label>
                <Select
                  name="meta.form_progress_event"
                  options={[
                    { label: 'Disabled', value: 'disabled' },
                    { label: 'User Input', value: 'user_input' },
                    { label: 'Filled Values', value: 'filled_values' },
                  ]}
                  value={this.state.meta?.form_progress_event || 'disabled'}
                  clearable={false}
                />
              </FormGroup>
            </Col>
            <Col size="2">
              <FormGroup>
                <Label>Active</Label>
                <Switch name="active" value={this.state.active || false} />
              </FormGroup>
            </Col>
            <Col size="4">
              <FormGroup>
                <Label>
                  Disable continue button
                  <InfoTip>
                    If true the continue button will be disabled until any required field were not filled.
                  </InfoTip>
                </Label>
                <Switch name="disable_continue_button" value={this.state.disable_continue_button || false} />
              </FormGroup>
            </Col>
          </Row>
        </SheetBody>
        <SheetFooter>
          <Button onClick={this.handleCancel} variant='ghost'>Cancel</Button>
          <Button type="submit" color='accent'>Save</Button>
        </SheetFooter>
      </Formsy>
    </DefaultSheet>
  }
}

FormComponent.propTypes = {
  slugs: PropTypes.array,
  onCancel: PropTypes.func,
  handleSubmit: PropTypes.func,
  data: PropTypes.any
};

export default FormComponent;
